import { Box, BoxProps, Button, Grid, Stack, Typography } from "@mui/material";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { useState } from "react";
import { IDetalharPrescricao } from "../../../../../../../types/api/receituarioAgronomico/detalhar-prescricoes";
import { DadosTitulosItems } from "../../index";
import DialogEditarInformacoesComplementares from "./Editar";
import { usePermission } from "../../../../../../../components/PermissionGuard";

interface CardDadosPrescricaoProps {
    boxStyle?: BoxProps;
    detalhe: IDetalharPrescricao;
    onSubmitStep: (payload: any) => void;
    isEditing?: boolean;
}

export default function InformacoesComplementares({ boxStyle, detalhe, onSubmitStep, isEditing }: CardDadosPrescricaoProps) {
    const [openEditModal, setOpenEditModal] = useState(false);

    const prescricao: IDetalharPrescricao = detalhe;

    const podeEditar = usePermission('receituario.editar-prescricao');

    const handleOpenEditModal = () => {
        setOpenEditModal(true);
    };

    const handleCloseEditModal = () => {
        setOpenEditModal(false);
    };

    return (
        <Box {...boxStyle}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h6">Informações complementares</Typography>
            </Stack>
            <Grid container spacing={2}>
                <Grid size={{xs: 12, sm: 6}}>
                    <DadosTitulosItems titulo="Complemento" valor={prescricao.complemento ?? "-"} />
                </Grid>
                <Grid size={{xs: 12, sm: 6}}>
                    <DadosTitulosItems titulo="Modo de aplicação" valor={prescricao.modo_aplicacao ?? "-"} />
                </Grid>
                <Grid size={{xs: 12, sm: 6}}>
                    <DadosTitulosItems titulo="Manejo" valor={prescricao.manejo ?? "-"} />
                </Grid>
                <Grid size={{xs: 12, sm: 6}}>
                    <DadosTitulosItems titulo="Época de aplicaçao" valor={prescricao.epoca_aplicacao ?? "-"} />
                </Grid>
                <Grid size={{xs: 12, sm: 6}}>
                    <DadosTitulosItems titulo="Grupo químico" valor={prescricao.grupo_quimico ?? "-"} />
                </Grid>
            </Grid>

            {podeEditar && (
                <Stack direction="row" justifyContent="flex-end" mt={2}>
                    <Button
                        variant="contained"
                        size="small"
                        startIcon={<EditOutlinedIcon />}
                        sx={{ fontSize: '0.75rem' }}
                        onClick={handleOpenEditModal}
                    >
                        Editar
                    </Button>
                </Stack>
            )}

            {openEditModal && (
                <DialogEditarInformacoesComplementares
                    open={openEditModal}
                    onClose={handleCloseEditModal}
                    isEditing={isEditing ?? false}
                    handleFormSubmit={(data) => {
                        onSubmitStep(data)
                        handleCloseEditModal()
                    }}
                />
            )}
        </Box>
    );
}